import React, { createContext, useContext, useState, ReactNode } from "react";
import { type ClientArenaFilter, type ClientArenaSort } from "~/graphql/supergraphTypes";

interface FilterSortContextType {
  filters: ClientArenaFilter[] | null;
  sorts: ClientArenaSort[] | null;
  setFilters: (filters: ClientArenaFilter[] | null) => void;
  setSorts: (sorts: ClientArenaSort[] | null) => void;
}

const FilterSortContext = createContext<FilterSortContextType | undefined>(undefined);

interface FilterSortProviderProps {
  children: ReactNode;
}

export const FilterSortProvider = ({ children }: FilterSortProviderProps) => {
  const [filters, setFilters] = useState<ClientArenaFilter[] | null>(null);
  const [sorts, setSorts] = useState<ClientArenaSort[] | null>(null);

  return (
    <FilterSortContext.Provider value={{ filters, sorts, setFilters, setSorts }}>
      {children}
    </FilterSortContext.Provider>
  );
};

export const useFilterSort = (): FilterSortContextType => {
  const context = useContext(FilterSortContext);
  if (context === undefined) {
    throw new Error("useFilterSort must be used within a FilterSortProvider");
  }
  return context;
};
